// ============================================================================
// Application roles (Spring Security authorities)
// ============================================================================

export const Role = {
  ADMIN: 'ROLE_ADMIN',
  PROFESSOR: 'ROLE_PROFESSOR',
} as const;

export type Role = (typeof Role)[keyof typeof Role];
